/* PatchAid purchase-flow diagnostics. No product/customer identifiers or external endpoints. */
(function (window, document) {
  'use strict';
  if (window.PatchAidMeasurement) return;

  var version = '2026-10-25.2';
  var names = [
    'selector_changed', 'bundle_configuration_blocked', 'bundle_ready',
    'shipping_eligibility_changed', 'checkout_intent', 'experiment_exposed', 'ui_error', 'performance_metric'
  ];
  var components = ['pdp', 'bundle', 'cart', 'shipping', 'homepage', 'navigation', 'storefront'];
  var errors = [
    'mixed_supply', 'cadence_mismatch', 'no_plan', 'unavailable_variant',
    'submit_failure', 'shipping_quote_unavailable'
  ];
  var recent = Object.create(null);
  var recentKeys = [];
  var exposed = Object.create(null);

  function includes(list, value) { return list.indexOf(value) !== -1; }
  function config() { return window.PatchAidMeasurementConfig || {}; }
  function allowed() {
    try {
      return !!(config().enabled === true &&
        window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  }
  function money(value) {
    return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 1000000
      ? Math.round(value * 100) / 100 : undefined;
  }
  function clean(input) {
    input = input && typeof input === 'object' ? input : {};
    var result = {schema_version: 1, release: version};
    if (includes(components, input.component)) result.component = input.component;
    if (includes(['one_time', 'subscription'], input.purchase_type)) result.purchase_type = input.purchase_type;
    if (includes([1, 2, 3, 6, 12], input.supply_months)) result.supply_months = input.supply_months;
    if (Number.isInteger(input.quantity) && input.quantity >= 0 && input.quantity <= 9999) result.quantity = input.quantity;
    if (money(input.merchandise_value) !== undefined) result.merchandise_value = money(input.merchandise_value);
    if (money(input.shipping_value) !== undefined) result.shipping_value = money(input.shipping_value);
    if (typeof input.currency === 'string' && /^[A-Z]{3}$/.test(input.currency)) result.currency = input.currency;
    if (typeof input.eligible === 'boolean') result.eligible = input.eligible;
    if (includes(errors, input.error_code)) result.error_code = input.error_code;
    if (includes(['LCP', 'CLS', 'INP'], input.metric) &&
        typeof input.metric_value === 'number' && Number.isFinite(input.metric_value) &&
        input.metric_value >= 0 && input.metric_value <= 1000000) {
      result.metric = input.metric;
      result.metric_value = Math.round(input.metric_value * 10000) / 10000;
      result.metric_unit = input.metric === 'CLS' ? 'score' : 'ms';
      result.measurement_method = 'native_observer_diagnostic';
    }

    var experiments = config().experiments || {};
    var experiment = Object.prototype.hasOwnProperty.call(experiments, input.experiment_id) ? experiments[input.experiment_id] : null;
    if (experiment && experiment.status === 'ready' &&
        /^[a-z0-9_]{1,64}$/.test(input.experiment_id) &&
        includes(['control', 'treatment'], input.variant) &&
        includes(experiment.variants || [], input.variant)) {
      result.experiment_id = input.experiment_id;
      result.variant = input.variant;
    }
    return result;
  }
  function publish(name, input) {
    if (!includes(names, name) || !allowed()) return false;
    if (!window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;
    var data = clean(input);
    if (!data.component) return false;
    if (name === 'performance_metric' && !data.metric) return false;
    if (name === 'experiment_exposed' && (!data.experiment_id || !data.variant)) return false;
    var exposureKey = data.experiment_id + ':' + data.variant + ':' + data.component;
    if (name === 'experiment_exposed' && exposed[exposureKey]) return false;
    var key = name + ':' + JSON.stringify(data);
    var now = Date.now();
    if (recent[key] !== undefined && now - recent[key] < 1000) return false;
    try {
      var result = window.Shopify.analytics.publish('patchaid:' + name, data);
      if (result === false) return false;
      if (result && typeof result.catch === 'function') result.catch(function () {});
      recent[key] = now;
      recentKeys.push(key);
      if (recentKeys.length > 128) delete recent[recentKeys.shift()];
      if (name === 'experiment_exposed') exposed[exposureKey] = true;
      return true;
    } catch (_) { return false; }
  }

  window.PatchAidMeasurement = Object.freeze({
    version: version,
    track: publish,
    canTrack: allowed
  });
  document.addEventListener('patchaid:measure', function (event) {
    if (event.detail && typeof event.detail.name === 'string') {
      publish(event.detail.name, event.detail.data);
    }
  });

  // Real-visit diagnostics, finalized at first hide. No DOM targets, resource URLs,
  // interaction IDs or page paths are published. These are not a full web-vitals
  // implementation: iframe, prerender, BFCache and late-consent visits differ.
  var performanceStarted = false;
  var performanceFinished = false;
  var observers = [];
  var lcp;
  var cls = 0;
  var clsSupported = false;
  var sessionScore = 0;
  var sessionStart = 0;
  var lastShift = 0;
  var interactions = [];
  var interactionBaseline = 0;
  var privacyLoadRequested = false;
  function observe(type, consume, threshold) {
    if (!includes(window.PerformanceObserver.supportedEntryTypes || [], type)) return;
    try {
      var observer = new window.PerformanceObserver(function (list) {
        if (allowed()) consume(list.getEntries());
      });
      var options = {type: type, buffered: false};
      if (threshold !== undefined) options.durationThreshold = threshold;
      observer.observe(options);
      observers.push({observer: observer, consume: consume});
      if (type === 'layout-shift') clsSupported = true;
    } catch (_) { /* unsupported APIs must not affect shopping */ }
  }
  function interactionEntries(entries) {
    entries.forEach(function (entry) {
      if (!entry.interactionId || !Number.isFinite(entry.duration)) return;
      var existing = interactions.filter(function (item) { return item.id === entry.interactionId; })[0];
      if (existing) existing.duration = Math.max(existing.duration, entry.duration);
      else interactions.push({id: entry.interactionId, duration: entry.duration});
      interactions.sort(function (a, b) { return b.duration - a.duration; });
      interactions.splice(10);
    });
  }
  function startPerformance() {
    if (performanceStarted || performanceFinished || !allowed() || config().performance === false ||
        typeof window.PerformanceObserver !== 'function' || document.visibilityState === 'hidden') return;
    performanceStarted = true;
    interactionBaseline = window.performance && window.performance.interactionCount || 0;
    observe('largest-contentful-paint', function (entries) {
      entries.forEach(function (entry) { lcp = entry.startTime; });
    });
    observe('layout-shift', function (entries) {
      entries.forEach(function (entry) {
        if (entry.hadRecentInput || !Number.isFinite(entry.value)) return;
        if (sessionScore && entry.startTime - lastShift < 1000 && entry.startTime - sessionStart < 5000) {
          sessionScore += entry.value;
        } else { sessionScore = entry.value; sessionStart = entry.startTime; }
        lastShift = entry.startTime;
        cls = Math.max(cls, sessionScore);
      });
    });
    observe('event', interactionEntries, 40);
    observe('first-input', interactionEntries);
  }
  function finishPerformance() {
    if (!performanceStarted || performanceFinished) return;
    performanceFinished = true;
    observers.forEach(function (item) {
      try { if (allowed()) item.consume(item.observer.takeRecords()); item.observer.disconnect(); } catch (_) {}
    });
    if (!allowed()) return;
    function report(metric, value) {
      publish('performance_metric', {component: 'storefront', metric: metric, metric_value: value});
    }
    if (lcp !== undefined) report('LCP', lcp);
    if (clsSupported) report('CLS', cls);
    // Group events by interaction, keep ten slowest and estimate p98 from the
    // native count. Without interactionCount, use the longest observed event.
    if (interactions.length) {
      var count = Math.max(0, (window.performance && window.performance.interactionCount || 0) - interactionBaseline);
      report('INP', interactions[Math.min(interactions.length - 1, Math.floor(count / 50))].duration);
    }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') finishPerformance();
    else startPerformance();
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (allowed()) startPerformance();
    else {
      observers.forEach(function (item) { try { item.observer.disconnect(); } catch (_) {} });
      performanceFinished = performanceStarted;
    }
  });
  if (typeof window.addEventListener === 'function') window.addEventListener('pagehide', finishPerformance);
  startPerformance();
  // Load only Shopify's official privacy API, once. This does not grant consent.
  // Failure leaves the gate closed; a later consent event can initialize it.
  if (config().enabled === true && window.Shopify && !window.Shopify.customerPrivacy &&
      typeof window.Shopify.loadFeatures === 'function' && !privacyLoadRequested) {
    privacyLoadRequested = true;
    try {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
        if (!error) startPerformance();
      });
    } catch (_) { /* fail closed */ }
  }
})(window, document);
